import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { AppRoutingModule } from "./app-routing.module";
import {HttpClientModule} from "@angular/common/http";
import {AuthenticationService} from "./shared/services/authentication.service";
import {PaymentService} from "./shared/services/payment.service";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthenticationService,
    PaymentService
  ]
})
export class AppModule { }
